import { StatusEnum } from '../../Enum/StatusEnum';
import BaseEntity from '../BaseEntity.model';
import { CreatedBy } from '../Shared/CreatedBy.model';

export default interface IDevelopmentalHistoryModel extends BaseEntity {
    MemberId: string;
    RecordingDate: Date;
    MemberName: string;
    CreatedDate: Date;
    CreatedBy: CreatedBy;
    UpdatedDate: Date;
    UpdatedBy: CreatedBy;
    ContextualNonpersonalFactors: string;
    IsAIContextualNonpersonalFactors: boolean;
    ContextualNonpersonalFactorsOther: string;
    PertinentDevelopmentalIssues: string;
    IsAIPertinentDevelopmentalIssues: boolean;
    MothersPregnancyHistory: string;
    IsAIMothersPregnancyHistory: boolean;
    MothersPregnancyHistoryDetail: string;
    InfancyHistory: string;
    IsAIInfancyHistory: boolean;
    InfancyHistoryDetail: string;
    PreschoolHistory: string;
    IsAIPreschoolHistory: boolean;
    PreschoolHistoryDetail: string;
    ChildhoodHistory: string;
    IsAIChildhoodHistory: boolean;
    ChildhoodHistoryDetail: string;
    AdolescentHistory: string;
    IsAIAdolescentHistory: boolean;
    AdolescentHistoryDetail: string;
    PertinentSexualIssuesConcerns: string;
    IsAIPertinentSexualIssuesConcerns: boolean;
    AssessmentStatus: StatusEnum;
}

export class DevelopmentalHistoryModel implements IDevelopmentalHistoryModel {
    Id: string;
    MemberId: string;
    RecordingDate: Date;
    MemberName: string;
    CreatedDate: Date;
    CreatedBy: CreatedBy;
    UpdatedDate: Date;
    UpdatedBy: CreatedBy;
    ContextualNonpersonalFactors: string;
    ContextualNonpersonalFactorsOther: string;
    PertinentDevelopmentalIssues: string;
    MothersPregnancyHistory: string;
    MothersPregnancyHistoryDetail: string;
    InfancyHistory: string;
    InfancyHistoryDetail: string;
    PreschoolHistory: string;
    PreschoolHistoryDetail: string;
    ChildhoodHistory: string;
    ChildhoodHistoryDetail: string;
    AdolescentHistory: string;
    AdolescentHistoryDetail: string;
    PertinentSexualIssuesConcerns: string;
    AssessmentStatus: StatusEnum;
    IsAIContextualNonpersonalFactors: boolean;
    IsAIPertinentDevelopmentalIssues: boolean;
    IsAIMothersPregnancyHistory: boolean;
    IsAIInfancyHistory: boolean;
    IsAIPreschoolHistory: boolean;
    IsAIChildhoodHistory: boolean;
    IsAIAdolescentHistory: boolean;
    IsAIPertinentSexualIssuesConcerns: boolean;

    constructor() {
        this.Id = '';
        this.MemberId = '';
        this.MemberName = '';
        this.AssessmentStatus = 0;
    }
}
